//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
import { Button } from "@chakra-ui/react";
import { observer } from "mobx-react-lite";
import React from "react";
const Wrapper = ({ asForm, children, additional }) => {
  if (asForm) {
    return (
      <div className="clearfix">
        <span
          style={{ display: "block" }}
          className="float-right request-input-box"
        >
          {children}
        </span>
        {additional}
      </div>
    );
  }
  return children;
};
const EditableInput = ({
  className = "",
  text = "/hr",
  children,
  onSubmit,
  data = [],
  keyText = "",
  additional,
  asForm = false,
  containerClass = "col-sm-6 pd-right--0",
  contentClass = "col-sm-6 text-right pd-right--0 ",
  inputClass = "",
  buttonText = "Update",
  buttonStyles = { colorScheme: "green" },
  defaultState = false,
  isPromise = false,
  ...rest
}: any) => {
  const [typing, setTyping] = React.useState(defaultState);
  const [currentKey, setCurrentKey] = React.useState("");
  const [currentValue, setCurrentValue] = React.useState("");
  const buttonProps = asForm
    ? { type: "submit" }
    : {
        onClick: (event) => {
          let rr = onSubmit(event, { [currentKey]: currentValue });
          if (rr instanceof Promise) {
            rr.then(() => {
              setTyping(false);
            });
          } else {
            setTyping(false);
          }
        },
      };
  let childrens = (
    <div className="row">
      <div className={containerClass}>
        <Wrapper additional={additional} asForm={asForm}>
          {data.length > 0 ? (
            <>
              {data.map(
                (
                  { key, suffix = "", width, labelText = "", ..._input },
                  index,
                ) => {
                  return (
                    <div style={{}}>
                      {typing && currentKey === key && labelText ? (
                        <label>
                          <strong>{labelText}</strong>
                        </label>
                      ) : null}
                      {typing ? (
                        <>
                          {currentKey === key ? (
                            <>
                              <input
                                key={`${keyText} ${index}`}
                                {..._input}
                                onFocus={() => {
                                  setCurrentKey(key);
                                  setCurrentValue(_input.defaultValue);
                                  setTyping(true);
                                }}
                                onChange={(e) =>
                                  setCurrentValue(e.target.value)
                                }
                              />
                              {/* {suffix ? <span>{suffix}</span> : null} */}
                            </>
                          ) : null}
                        </>
                      ) : (
                        <>
                          <span style={{ cursor: "pointer" }}>
                            <input
                              key={`${keyText} ${index}`}
                              style={{ width, cursor: "pointer" }}
                              {..._input}
                              onFocus={() => {
                                setCurrentKey(key);
                                setCurrentValue(_input.defaultValue);
                                setTyping(true);
                              }}
                              onChange={(e) => setCurrentValue(e.target.value)}
                            />
                            {suffix ? (
                              <span
                                onClick={() => {
                                  setCurrentKey(key);
                                  setCurrentValue(_input.defaultValue);
                                  setTyping(true);
                                }}
                              >
                                {suffix}
                              </span>
                            ) : null}
                          </span>
                        </>
                      )}
                    </div>
                  );
                },
              )}
            </>
          ) : (
            <>
              <input
                className={inputClass}
                {...rest}
                onFocus={() => setTyping(true)}
              />
              <span>{text}</span>
            </>
          )}
        </Wrapper>
      </div>
      <div className={contentClass}>
        {typing ? (
          <React.Fragment>
            <span
              aria-hidden="true"
              title="show tutor's default subject"
              style={{ marginRight: "10px", cursor: "pointer" }}
              onClick={() => setTyping(false)}
            >
              &times;
            </span>
            <Button
              size="sm"
              className="ft-14 btn "
              {...buttonProps}
              {...buttonStyles}
            >
              {buttonText}
            </Button>
          </React.Fragment>
        ) : (
          children
        )}
      </div>
    </div>
  );
  if (asForm) {
    return (
      <form
        className={className}
        onSubmit={(...v) => {
          if (isPromise) {
            onSubmit(...v).then(() => {
              setTyping(false);
            });
          } else {
            onSubmit(...v);
            setTyping(false);
          }
        }}
      >
        {childrens}
      </form>
    );
  }
  return <div className={className}>{childrens}</div>;
};

export default observer(EditableInput);
